import {
  computed,
  onBeforeUnmount,
  onMounted,
  useStore,
  watch
} from '@nuxtjs/composition-api'
import { immediateRefreshToken$ } from '../modules/client/utilities'
import useErrorHandler from './useErrorHandler'

export default function useListeningToRefreshToken(context) {
  const store = useStore()

  const token = computed(() => store.state.authModule.token)
  watch(token, newVal => {
    if (newVal) {
      listeningToRefreshToken()
    } else {
      stopListeningToRefreshToken()
    }
  })

  onMounted(() => {
    if (token.value) {
      listeningToRefreshToken()
    }
  })

  onBeforeUnmount(() => {
    stopListeningToRefreshToken()
  })

  let intervalId = null
  const { errorHandler } = useErrorHandler(context)
  function listeningToRefreshToken() {
    if (intervalId !== null) return

    intervalId = setInterval(() => {
      immediateRefreshToken$({
        ...store,
        rootState: store.state
      }).subscribe({
        error: err => {
          errorHandler(err, err => {
            if (err.statusCode === 401) {
              stopListeningToRefreshToken()
            }
            return true
          })
        }
      })
    }, parseInt(process.env.REFRESH_TOKEN_EVERY_MINUTES || '20') * 60 * 1000)
  }
  function stopListeningToRefreshToken() {
    if (!intervalId) return
    clearInterval(intervalId)
    intervalId = null
  }
}
